export const ANALYTICS_EVENTS = {
  SEARCH: 'Search',
  SUBMISSION: 'New submission',
  CONTACT_US: 'Contact us',
  CONSULTATION: 'Consultation request',
  SUBSCRIBE: 'Subscribe',
};
